import { PermissionEnum } from "types";

export const SETUP_PERMISSIONS = [
  PermissionEnum.ManageProduct,
  PermissionEnum.ManagePasswordPolicy,
  PermissionEnum.ListRole,
  PermissionEnum.ManageTasks,
  PermissionEnum.ManageKybTask,
  PermissionEnum.ManageFees,
  PermissionEnum.ManagePaymentCategories,
];

export const LOOK_AND_FEEL_PERMISSIONS = [
  PermissionEnum.ManageBranding,
  PermissionEnum.ManageTranslation,
];

export const CONTENT_MANAGEMENT_PERMISSIONS = [
  PermissionEnum.ManageDocument,
  PermissionEnum.ManageForms,
];

export const INTERNAL_PERMISSIONS = [
  PermissionEnum.ManageInternal,
  PermissionEnum.ManageSupportTools,
];

export const SUBSCRIPTION_REQUESTS_PERMISSIONS = [PermissionEnum.ViewBenefit];

export const COMPANY_REQUESTS_PERMISSIONS = [PermissionEnum.ViewKybTask];

export const EMPLOYEE_REQUESTS_PERMISSIONS = [PermissionEnum.ViewKycTask];

export const REQUESTS_PERMISSIONS = [
  ...SUBSCRIPTION_REQUESTS_PERMISSIONS,
  ...COMPANY_REQUESTS_PERMISSIONS,
  ...EMPLOYEE_REQUESTS_PERMISSIONS,
];

export const CONTROLS_PERMISSIONS = [
  ...SETUP_PERMISSIONS,
  ...LOOK_AND_FEEL_PERMISSIONS,
  ...CONTENT_MANAGEMENT_PERMISSIONS,
  ...INTERNAL_PERMISSIONS,
];
